// 1. 성별 리스트
export const genderList = ["남성", "여성", "기타"];
export const artechCollabCountList = ["0회", "1~2회", "3~4회", "5~9회", "10회 이상"];
// 2. 연령대 리스트 (청년층 중심으로 좀 더 촘촘하게)
export const ageRangeList = [
    "10대 초반 (10-13세)",
    "10대 중반 (14-16세)",
    "10대 후반 (17-19세)",
    "20대 초반 (20-23세)",
    "20대 중반 (24-26세)",
    "20대 후반 (27-29세)",
    "30대 초반 (30-33세)",
    "30대 중반 (34-36세)",
    "30대 후반 (37-39세)",
    "40대 초반 (40-43세)",
    "40대 중반 (44-46세)",
    "40대 후반 (47-49세)",
    "50대 초반 (50-53세)",
    "50대 중반 (54-56세)",
    "50대 후반 (57-59세)",
    "60대 초반 (60-63세)",
    "60대 중반 (64-66세)",
    "60대 후반 (67-69세)",
    "60대 이상"
  ];


// 3. 직업 리스트 (예술, 기술, 기획 분야 중심 예시)
export const jobList = [
  // [예술가 30]
  "회화 작가",
  "조각가",
  "공예가",
  "설치미술가",
  "퍼포먼스 아티스트",
  "미디어 아티스트",
  "영상 아티스트",
  "사진 작가",
  "그래픽 디자이너",
  "일러스트레이터",
  "패션 디자이너",
  "무대 디자이너",
  "음악 작곡가",
  "음악 연주가",
  "연극 배우",
  "영화 감독",
  "애니메이션 작가",
  "캘리그래퍼",
  "시각 디자이너",
  "서예가",
  "웹툰 작가",
  "만화가",
  "미술 교사/강사",
  "키네틱 아티스트",
  "오디오 비주얼 아티스트",
  "게임 아티스트",
  "사운드 아티스트",
  "라이브 드로잉 아티스트",
  "퍼블릭 아티스트",
  "공연연출가",

  // [기술자 30]
  "소프트웨어 엔지니어",
  "웹 개발자",
  "게임 프로그래머",
  "VR/AR 개발자",
  "모바일 앱 개발자",
  "머신러닝 엔지니어",
  "데이터 사이언티스트",
  "시스템 엔지니어",
  "네트워크 엔지니어",
  "보안 전문가",
  "로보틱스 엔지니어",
  "전자공학 엔지니어",
  "기계공학 엔지니어",
  "화공 엔지니어",
  "재료공학 엔지니어",
  "메카트로닉스 엔지니어",
  "음향 엔지니어",
  "빅데이터 엔지니어",
  "DevOps 엔지니어",
  "임베디드 소프트웨어 엔지니어",
  "IoT 엔지니어",
  "클라우드 엔지니어",
  "3D 프린팅 엔지니어",
  "자율주행 엔지니어",
  "UX/UI 엔지니어",
  "컴퓨터 그래픽스 엔지니어",
  "블록체인 엔지니어",
  "Bio Tech 엔지니어",
  "에너지/환경 엔지니어",
  "드론 엔지니어",

  // [기획자 30]
  "프로젝트 기획자",
  "전시 기획자",
  "공연 기획자",
  "행사 기획자",
  "축제 기획자",
  "문화기획자",
  "박물관/갤러리 기획자",
  "마케팅 기획자",
  "브랜드 기획자",
  "미디어 콘텐츠 기획자",
  "게임 기획자",
  "인터랙션 기획자",
  "교육 프로그램 기획자",
  "융합 콘텐츠 기획자",
  "스마트 시티 기획자",
  "소셜벤처 기획자",
  "UX/UI 기획자",
  "프로덕트 매니저(PM)",
  "크리에이티브 디렉터",
  "미술관 에듀케이터",
  "비즈니스 기획자",
  "스타트업 기획자",
  "디지털 마케팅 기획자",
  "공연/전시 투어 매니저",
  "게임 이벤트 기획자",
  "아트 페어 기획자",
  "체험형 전시 기획자",
  "비대면 콘텐츠 기획자",
  "SNS 콘텐츠 기획자",
  "패션쇼 기획자",
  
  // [일반 직업 100개]
  "의사",
  "간호사",
  "약사",
  "물리치료사",
  "치과의사",
  "한의사",
  "수의사",
  "작업치료사",
  "임상병리사",
  "방사선사",
  "치위생사",
  "영양사",
  "의료기사",
  "응급구조사",
  "보건교사",
  "초등학교 교사",
  "중학교 교사",
  "고등학교 교사",
  "교수",
  "특수교육 교사",
  "학원 강사",
  "보육교사",
  "유치원 교사",
  "사서",
  "사회복지사",
  "심리상담사",
  "변호사",
  "판사",
  "검사",
  "변리사",
  "법무사",
  "공인중개사",
  "세무사",
  "회계사",
  "관세사",
  "노무사",
  "경찰",
  "소방관",
  "군인",
  "교도관",
  "해양경찰",
  "공무원",
  "외교관",
  "국회의원",
  "정치인",
  "기자",
  "아나운서",
  "PD",
  "작가",
  "편집자",
  "번역가",
  "통역사",
  "광고 카피라이터",
  "방송작가",
  "시나리오 작가",
  "출판물 편집자",
  "요리사",
  "제빵사",
  "바리스타",
  "소믈리에",
  "조리사",
  "푸드스타일리스트",
  "영양컨설턴트",
  "호텔리어",
  "여행 가이드",
  "관광통역사",
  "항공승무원",
  "크루즈승무원",
  "여행상품 개발자",
  "운동선수",
  "스포츠 코치",
  "스포츠 트레이너",
  "스포츠 심판",
  "스포츠 에이전트",
  "요가 강사",
  "필라테스 강사",
  "헬스 트레이너",
  "은행원",
  "증권사 직원",
  "투자분석가",
  "보험설계사",
  "펀드매니저",
  "재무상담사",
  "부동산 전문가",
  "매장 관리자",
  "판매사원",
  "제품 판매원",
  "매장 점장",
  "고객서비스 담당자",
  "텔레마케터",
  "운전기사",
  "택배기사",
  "배달원",
  "농부",
  "어부",
  "임업인",
  "조경사",
  "환경컨설턴트",
  "단순노무자",
  "청소부",
  "가사도우미",
  "파티플래너",
  
  // [추가 직업 100개 - 사무직/기타]
  "일반 사무원",
  "인사 담당자",
  "총무 담당자",
  "경리 담당자",
  "회계 담당자",
  "비서",
  "행정 보조원",
  "사무 보조원",
  "데이터 입력원",
  "콜센터 상담원",
  "전화 상담원",
  "고객 지원 담당자",
  "리셉션니스트",
  "서류 관리자",
  "문서 작성자",
  "법률 사무원",
  "의료 사무원",
  "학교 행정직원",
  "대학 행정직원",
  "인사 컨설턴트",
  "채용 담당자",
  "급여 관리자",
  "복리후생 담당자",
  "교육 담당자",
  "노무 담당자",
  "기획 사무원",
  "통계 사무원",
  "마케팅 사무원",
  "홍보 사무원",
  "영업 사무원",
  "구매 담당자",
  "자재 관리자",
  "물류 관리자",
  "무역 사무원",
  "수출입 담당자",
  "관세 사무원",
  "보험 사무원",
  "증권 사무원",
  "은행 사무원",
  "카드사 사무원",
  "금융 사무원",
  "부동산 사무원",
  "공인중개 사무원",
  "건설 사무원",
  "공사 관리 사무원",
  "제조업 사무원",
  "생산 관리 사무원",
  "품질 관리 사무원",
  "안전 관리 사무원",
  "환경 관리 사무원",
  "시설 관리 사무원",
  "주차 관리원",
  "경비원",
  "건물 관리인",
  "아파트 관리소장",
  "주택 관리사",
  "환경미화원",
  "재활용 수거원",
  "환경 관리인",
  "방역원",
  "소독원",
  "청소 관리자",
  "가정 교사",
  "방과후 교사",
  "돌봄 교사",
  "놀이 지도사",
  "장애인 도우미",
  "노인 요양보호사",
  "산후 도우미",
  "육아 도우미",
  "베이비시터",
  "아이 돌보미",
  "간병인",
  "동물 보호사",
  "애완동물 미용사",
  "동물 훈련사",
  "수족관 관리사",
  "식물원 관리인",
  "화훼 재배사",
  "원예 관리사",
  "조경 관리인",
  "정원사",
  "화훼 장식가",
  "웨딩플래너",
  "이벤트 플래너",
  "장례지도사",
  "미용사",
  "피부 관리사",
  "메이크업 아티스트",
  "네일 아티스트",
  "헤어 디자이너",
  "스타일리스트",
  "마사지사",
  "스파 테라피스트",
  "침술사",
  "지압사",
  "체형 교정사",
  "다이어트 컨설턴트",
  
  // [추가 직업 200개]
  // 과학/연구 분야
  "천문학자",
  "물리학자",
  "생물학자",
  "화학자",
  "지질학자",
  "기상학자",
  "해양학자",
  "인류학자",
  "고고학자",
  "역사학자",
  "언어학자",
  "심리학자",
  "사회학자",
  "인공지능 연구원",
  "로봇공학 연구원",
  "유전공학 연구원",
  "뇌과학 연구원",
  "우주과학 연구원",
  "나노기술 연구원",
  "생명공학 연구원",
  
  // 제조/생산/건설 분야
  "자동차 정비사",
  "항공기 정비사",
  "선박 정비사",
  "전기 기술자",
  "가스 기술자",
  "보일러 기술자",
  "용접공",
  "배관공",
  "목수",
  "도배공",
  "페인트공",
  "석공",
  "단열공",
  "유리 시공사",
  "지붕 시공사",
  "철근공",
  "콘크리트 기술자",
  "크레인 운전사",
  "불도저 운전사",
  "포크레인 운전사",
  "건설장비 운전사",
  "도로 건설 기술자",
  "교량 건설 기술자",
  "터널 건설 기술자",
  "철도 건설 기술자",
  "건축감리사",
  "안전검사관",
  "구조 기술자",
  
  // IT/디지털 분야
  "앱 개발자",
  "프론트엔드 개발자",
  "백엔드 개발자",
  "풀스택 개발자",
  "게임 서버 개발자",
  "게임 클라이언트 개발자",
  "인공지능 개발자",
  "자연어처리 전문가",
  "컴퓨터 비전 전문가",
  "데이터 엔지니어",
  "데이터베이스 관리자",
  "시스템 관리자",
  "클라우드 아키텍트",
  "네트워크 관리자",
  "정보보안 전문가",
  "사이버 보안 분석가",
  "화이트해커",
  "QA 엔지니어",
  "테스트 엔지니어",
  "인프라 엔지니어",
  "SEO 전문가",
  "그로스 해커",
  "웹 퍼블리셔",
  "디지털 마케터",
  "IT 컨설턴트",
  "IT 트레이너",
  "기술 문서 작성자",
  
  // 운송/물류 분야
  "버스 운전사",
  "트럭 운전사",
  "택시 운전사",
  "열차 기관사",
  "지하철 기관사",
  "선장",
  "항해사",
  "파일럿(비행기 조종사)",
  "헬리콥터 조종사",
  "드론 조종사",
  "교통관제사",
  "비행 관제사",
  "해상 교통관제사",
  "물류 센터 관리자",
  "운송 조정자",
  "포워더",
  "창고 관리자",
  "선적 관리자",
  "배송 관리자",
  "항공 화물 전문가",
  
  // 미디어/엔터테인먼트 분야
  "방송 기술자",
  "음향 기술자",
  "조명 기술자",
  "영화 촬영기사",
  "영화 편집자",
  "방송 편집자",
  "스크립터",
  "카메라 오퍼레이터",
  "스튜디오 엔지니어",
  "특수효과 기술자",
  "애니메이터",
  "3D 모델러",
  "모션 그래픽 디자이너",
  "UI 디자이너",
  "UX 디자이너",
  "사운드 디자이너",
  "음악 프로듀서",
  "음반 제작자",
  "방송 진행자",
  "스포츠 해설가",
  "성우",
  "팟캐스트 진행자",
  "게임 스트리머",
  "유튜버",
  "인플루언서",
  "SNS 매니저",
  
  // 교육/연구 지원 분야
  "교육 연구원",
  "교육과정 개발자",
  "교재 개발자",
  "이러닝 개발자",
  "교육 컨설턴트",
  "교육 평가사",
  "진로 상담사",
  "학습 코치",
  "학습 치료사",
  "재활 치료사",
  "연구 보조원",
  "실험실 테크니션",
  "대학원 조교",
  "도서관 사서 보조",
  "연구소 행정직원",
  
  // 판매/서비스 분야
  "보석 감정사",
  "시계 수리공",
  "악기 수리공",
  "예술품 복원가",
  "골동품 감정사",
  "와인 전문가",
  "맥주 양조사",
  "커피 로스터",
  "차 소믈리에",
  "향수 제조사",
  "캔들 메이커",
  "수제비누 제작자",
  "디저트 전문가",
  "케이크 디자이너",
  "초콜릿 전문가",
  "꽃집 운영자",
  "선물 포장 전문가",
  "파티 용품 디자이너",
  "의상 대여업자",
  "주얼리 디자이너",
  "인테리어 디자이너",
  "공간 디자이너",
  "가구 디자이너",
  "조명 디자이너",
  "텍스타일 디자이너",
  "제품 디자이너",
  "패키지 디자이너",
  
  // 농업/임업/어업/환경 분야
  "유기농 농부",
  "수경재배 전문가",
  "곤충 농장 운영자",
  "종자 전문가",
  "과수원 관리자",
  "와인 포도농장 관리자",
  "목장 운영자",
  "양봉가",
  "버섯 재배자",
  "약초 재배자",
  "산림 관리인",
  "사냥 가이드",
  "산불 감시원",
  "자연 보호구역 관리인",
  "생태학 조사관",
  "어류 양식업자",
  "해조류 양식업자",
  "해양 생태계 보전가",
  "환경 영향 평가원",
  "폐기물 관리 전문가",
  
  // 기타 특수 직업
  "비행선 조종사",
  "잠수함 운전사",
  "전문 서퍼",
  "스노우보드 강사",
  "산악 가이드",
  "동굴 탐험 가이드",
  "정글 탐험 가이드",
  "극지 탐험가",
  "구호 활동가",
  "평화 활동가",
  "자원봉사 코디네이터",
  "위기 상담사",
  "미술 치료사",
  "음악 치료사",
  "원예 치료사",
  "역사 재연 배우",
  "우표 감정사",
  "애완동물 심리학자",
  "행동 분석가",
  "도시 계획가",
  "사물인터넷 전문가",
  "빅데이터 분석가",
  "핀테크 전문가",
  "가상화폐 전문가",
  "미래학자",
  "인공위성 엔지니어",
  "로켓 엔지니어",
  "자율주행차 설계자",
  "로봇 프로그래머",
  "3D 바이오프린팅 전문가"
];


// 4. 국가 리스트 (맨 위에 South Korea, 이후 알파벳순)
export const countryList = [
  "South Korea",
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo, Democratic Republic of the",
  "Congo, Republic of the",
  "Costa Rica",
  "Côte d'Ivoire",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "North Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "North Korea",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "St Kitts and Nevis",
  "St Lucia",
  "St Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe"
];
